import { Component, Input } from '@angular/core';

/**
 * Iconos de los materiales que el operario debe retirar de oficina para una cita, con el detalle
 * en el tooltip. Las relaciones llegan por Input para que core no dependa de modules: quien lo usa
 * es el que las carga con include('materials.material').
 */
@Component({
    selector: 'app-case-service-materials',
    templateUrl: './case-service-materials.component.html',
    styleUrls: ['./case-service-materials.component.scss'],
    standalone: false
})
export class CaseServiceMaterialsComponent {
  /** Relaciones cita-material, tal cual llegan del include. */
  @Input() materials: any[] | null | undefined = [];

  /**
   * Tooltip propio con los nombres. Se desactiva donde el contenedor ya tiene su propio tooltip,
   * como los huecos de la rejilla de planificacion: dos tooltips anidados se pisan.
   */
  @Input() showTooltip: boolean = true;

  public get items(): any[] {
    return (this.materials ?? []).filter((relation: any) => !!relation?.material);
  }

  /** Nombres separados por coma, para el tooltip. */
  public get tooltip(): string {
    return this.items.map((relation: any) => relation.material.name).join(', ');
  }

  /** Icono del material, con uno generico de reserva si la ficha no tiene ninguno. */
  public iconOf(relation: any): string {
    return relation.material.iconClass || 'pi pi-box';
  }
}
